import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { map, Observable } from 'rxjs';
import { UserService } from './services/user.service';

@Injectable({
  providedIn: 'root',
})
export class ValidateUserDataGuard implements CanActivate {
  constructor(
    private router: Router,
    private userService: UserService) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> {

    return this.authorize();
  }

  authorize(): Promise<boolean> {

    return new Promise((resolve, reject) => {

      this.userService.validateToken().subscribe({
        next: () => {
          resolve(true)
        },
        error: (err) => {
          resolve(false)
        }
      })
    });
  }
}
